import { INTEGRATION_STATUS } from '../../constants';

export default function integrationSync($rootScope, Authentication, IntegrationService) {
  'ngInject';

  return {
    restrict: 'A',
    async link($scope, $element, $attrs) {
      const integrations = await IntegrationService.getAvailableIntegrations();
      const type = $attrs.integrationSync;

      if (!type || !Authentication.user.isAdmin) {
        $element.remove();
        return;
      }

      const integration = integrations.find((el) => el.type === type);

      if (!integration || !integration.id || integration.status === INTEGRATION_STATUS.DISABLED) {
        $element.remove();
        return;
      }

      if (integration.status !== INTEGRATION_STATUS.ENABLED) {
        disable($element);
      }

      $element.on('click', () => {
        disable($element);
        IntegrationService.sync(integration).catch(() => enable($element));
      });

      const handler = (event, { platform = null, status = null } = {}) => {
        if (!platform || !status) {
          return;
        }
        if (platform === type && status === INTEGRATION_STATUS.ENABLED) {
          enable($element);
        } else {
          disable($element);
        }
      };

      $scope.$on('$destroy', IntegrationService.subscribeWebsockets(handler));
    },
  };
}

function disable($element) {
  $element.triggerHandler('mouseout');
  $element.prop('disabled', true);
  $element.addClass('disabled');
}

function enable($element) {
  $element.prop('disabled', false);
  $element.removeClass('disabled');
}
